import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
 
export default function useForceStayOnSite(enabled = true) {
  const navigate = useNavigate();
  const location = useLocation();
  const [showExitPopup, setShowExitPopup] = useState(false);
  const isHandlingBack = useRef(false);
 
  useEffect(() => {
    if (!enabled) return;
 
    // Lock current page
    window.history.pushState({ locked: true }, "", location.pathname);
    const handlePopState = (event) => {
      if (isHandlingBack.current) return;
      isHandlingBack.current = true;
      setShowExitPopup(true);
      window.history.pushState({ locked: true }, "", location.pathname);
      setTimeout(() => {
        isHandlingBack.current = false;
      }, 0);
    };
 
    window.addEventListener("popstate", handlePopState);
 
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [enabled, location.pathname]);
 
  const handleCancel = () => {
    setShowExitPopup(false);
    // Stay on same page safely
    window.history.pushState({ locked: true }, "", location.pathname);
  };
 
  const handleOk = () => {
    setShowExitPopup(false);
 
    // Allow exit
    navigate("/", { replace: true }); // logout / home
  };
 
  return {
    showExitPopup,
    handleCancel,
    handleOk,
  };
}
 
 